__turbopack_context__.v({
  "container": "Star-module__xhQ4xq__container",
});
